import { render, staticRenderFns } from "./QueryPolicyCoverage.vue?vue&type=template&id=9c4434bc&"
import script from "./QueryPolicyCoverage.vue?vue&type=script&lang=js&"
export * from "./QueryPolicyCoverage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports